import { defineComponent, h } from "vue";
import { useStore } from "../../../node_modules/vuex/dist/vuex.mjs";
import ProductPage from "../../components/ProductPage/ProductPage.mjs";
import AddToCartInterstitial from "../../components/AddToCartInterstitial/AddToCartInterstitial.mjs";
import "core-js/modules/es.array.push.js";
import { INIT_PRODUCT_PAGE_CREATE_START, INIT_PRODUCT_PAGE_CREATED, INIT_PRODUCT_PAGE_MOUNT, CLEANUP_PRODUCT_PAGE, ADD_TO_CART_BUYBOX_FLOW, METRICS_CLICK, HANDLE_RECS_CLICK, TRIGGER_PAGE_BACK, ADD_MEMBERSHIP_TO_CART, OPEN_PREORDER_MODAL, OPEN_MODAL } from "../../store/constants.mjs";
import "bezier-easing";
import { logger } from "../../util/logger.mjs";
import "js-cookie";
import "core-js/modules/esnext.set.difference.v2.js";
import "core-js/modules/esnext.set.intersection.v2.js";
import "core-js/modules/esnext.set.is-disjoint-from.v2.js";
import "core-js/modules/esnext.set.is-subset-of.v2.js";
import "core-js/modules/esnext.set.is-superset-of.v2.js";
import "core-js/modules/esnext.set.symmetric-difference.v2.js";
import "core-js/modules/esnext.set.union.v2.js";
import "@rei/session";
import useProductPageStore from "../../stores/productPageStore.mjs";
import useProductAppPropsStore from "../../stores/productAppPropsStore.mjs";
const ProductPageContainer = defineComponent({
  name: "ProductPageContainer",
  setup() {
    var _a, _b;
    const vuex = useStore();
    let appPropsStore;
    let productPageStore;
    if ((_b = (_a = vuex == null ? void 0 : vuex.getters) == null ? void 0 : _a.appPropsMap) == null ? void 0 : _b.launchToggles.usePinia) {
      appPropsStore = useProductAppPropsStore();
      productPageStore = useProductPageStore();
    }
    return { appPropsStore, productPageStore };
  },
  beforeCreate() {
    var _a, _b, _c;
    this.$store.dispatch(INIT_PRODUCT_PAGE_CREATE_START);
    if ((_b = (_a = this.$store.getters.appPropsMap) == null ? void 0 : _a.launchToggles) == null ? void 0 : _b.usePinia) {
      (_c = this.productPageStore) == null ? void 0 : _c.initProductPageCreateStart();
    }
  },
  created() {
    if (typeof window !== "undefined") this.$store.dispatch(INIT_PRODUCT_PAGE_CREATED);
  },
  mounted() {
    var _a, _b;
    this.$store.dispatch(INIT_PRODUCT_PAGE_MOUNT);
    try {
      const { type } = this.$store.state.product.displayOptions.pupInfo;
      const isOutlet = this.$store.state.product.outlet;
      logger.log("PDP Info:", {
        isOutlet,
        pupInfo: type,
        mixedPrice: (_a = this.$store.state.product) == null ? void 0 : _a.mixedPriceOptions,
        akamaiExperienceName: (_b = this.$store.state.analytics) == null ? void 0 : _b.akamaiExperienceName
      });
    } catch (error) {
      logger.error(error);
    }
  },
  beforeUnmount() {
    this.$store.dispatch(CLEANUP_PRODUCT_PAGE);
  },
  render() {
    const {
      getters,
      dispatch,
      state
    } = this.$store;
    const renderPDP = h(ProductPage, {
      ...getters.productPageProps,
      /* BV content requires the PDP stay mounted when we show the add to cart interstitial */
      style: { display: state.showAddToCartInterstitial ? "none" : null },
      onAddToCart: (data) => dispatch(ADD_TO_CART_BUYBOX_FLOW, data),
      onMetricsClick: (data) => dispatch(METRICS_CLICK, data),
      onRecsClick: (data) => dispatch(HANDLE_RECS_CLICK, { data })
    });
    const renderAddToCartInterstitial = h(AddToCartInterstitial, {
      ...getters.cartItemData,
      onInterstitialContinueShopping: () => dispatch(TRIGGER_PAGE_BACK),
      onMetricsClick: (data) => dispatch(METRICS_CLICK, data),
      onRecsClick: (data) => dispatch(HANDLE_RECS_CLICK, { data }),
      onAddMembershipToCart: (data) => dispatch(ADD_MEMBERSHIP_TO_CART, data),
      onPreorderBannerClick: () => dispatch(OPEN_PREORDER_MODAL),
      onModalOpen: (data) => dispatch(OPEN_MODAL, data)
    });
    return [
      state.showAddToCartInterstitial ? renderAddToCartInterstitial : null,
      renderPDP
    ];
  }
});
export {
  ProductPageContainer as default
};
//# sourceMappingURL=ProductPageContainer.mjs.map
